import { render, staticRenderFns } from "./TaxiHome.vue?vue&type=template&id=5b66c7f1&scoped=true&"
import script from "./TaxiHome.vue?vue&type=script&lang=js&"
export * from "./TaxiHome.vue?vue&type=script&lang=js&"
import style0 from "./TaxiHome.vue?vue&type=style&index=0&id=5b66c7f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66c7f1",
  null
  
)

export default component.exports